import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as userActions from '@/store/actions/user';
import * as msgNumActions from '@/store/actions/msgNum';
import * as dateNumActions from '@/store/actions/dateNum';
import * as boxActions from '@/store/actions/selectBox';
import * as appActions from '@/store/actions/app';
import { Link } from 'react-router-dom';
import history from '@/containers/history';
import { Scrollbars } from 'react-custom-scrollbars';
import { Menu, Badge, Dropdown, Icon, Row, Col, message, Modal, Button, Popover, Avatar, Input, Select, List, Spin } from 'antd';
import { loginOut, reqByGet, getOrgList_box, getLabList_box, getRoleList_box, getDataList_box, getComboxList_box, getTrainUserList_box, getMsgNum, getlabRoleList_box, getLabUserList, switchLabHandle } from '@/api/api';
import servers from '@/api/server';
import utils from '@/api/util'
import styles from './Header.module.less';
import './index.css'
import routers from '@/containers/routers'

const SubMenu = Menu.SubMenu;
class Header extends Component {
  constructor(props) {
    super(props);
    console.log(props)
    let settingMenu;
    if (props.user.treeList && props.user.treeList.find(x => { return x.value === 279 })) {
      settingMenu = props.user.treeList.find(x => { return x.value === 279 })
    };
    console.log(settingMenu)
    this.state = {
      msgNum: 0,
      isOne: 0,
      isTwo: 0,
      resulFlag: true,
      poDivSpin: false,
      msgFlag: true,
      msgFlag1: true,
      pageName: '',
      settingMenu: settingMenu,
      labMenus: this.props.user.labList,
      menuList: this.props.user.treeList,
      curLab: {}
    }
    this.switchLab = this.switchLab.bind(this);
    this.menuClick = this.menuClick.bind(this)
  }

  componentDidMount() {
    const that = this;
    if (this.props.path) {
      console.log(this.props.path)
      utils.treeFilter(routers, 'path', that.props.path).then(res => {
        console.log(res)
        this.setState({
          pageName: res.name
        })
      })
    }
    if (this.props.user.labList.length) {
      let curLab = this.props.user.labList.find(x => {
        return x.isDef === 2;
      });
      if (curLab) {
        that.setState({
          curLab
        })
      }
    }
    that.props.updateDateNum()
  }

  // 2.6实验室下拉改变，更新缓存
  switchLab(lab) {
    const that = this;
    console.log(lab);
    if (lab === that.state.curLab) {
      return
    };
    that.state.labMenus.map(x => {
      if (x === lab) {
        x.isDef = 2
      } else {
        x.isDef = 1
      }
    })
    that.setState({
      curLab: lab
    });
    switchLabHandle({ userLinkId: lab.userLinkId }, res => {
      console.log(res);
      if (res.statusCode !== 1000) {
        message.error(res.message, 2);
        return
      };
      let settingMenu;
      if (res.treeList && res.treeList.find(x => { return x.value === 279 })) {
        settingMenu = res.treeList.find(x => { return x.value === 279 })
      };
      console.log(settingMenu)
      that.setState({
        menuList: res.treeList,
        settingMenu: settingMenu,
      })
      let user = Object.assign({}, that.props.user, {
        treeList: res.treeList,
        userObj: res.userObj,
        labList: that.state.labMenus
      });
      localStorage.setItem('user', JSON.stringify(user));
      getRoleList_box({}, res => { //获取角色下拉列表
        that.props.role_input(res.roleBoxList)
      }, err => {
        console.log(err)
      })

      getlabRoleList_box({}, res => {
        that.props.labRole_input(res.roleBoxList)
      }, err => {
        console.log(err)
      })
      that.props.updateMsgNum();
      history.push({
        pathname: '/homePage',
        query: {
          refresh: true
        }
      });
    }, err => {
      console.log(err)
    })
  }
  // 退出登陆
  loginOut = () => {
    const that = this;
    loginOut({}, res => {
      that.props.loginOut();
    }, err => {
      console.log(err)
    })
  }
  menuClick(key) {
    console.log(key)
    this.props.updateHeaderPaneKey(key.key);
  };
  onclickAllRead = () => {
    this.props.updateMsgOnekey(true);
  }
  showRule = () => {
    let httpStr = servers.basePath + '/resources/document/（APP-normal）杂交水稻国家重点实验室管理系统产品使用手册.docx';
    let httpStr1 = servers.basePath + '/resources/document/（APP-管理员）杂交水稻国家重点实验室管理系统产品使用手册.docx';
    let httpStr2 = servers.basePath + '/resources/document/（C端程序）杂交水稻国家重点实验室管理系统产品使用手册.doc';
    let httpStr3 = servers.basePath + '/resources/document/（PC web）杂交水稻国家重点实验室管理系统产品使用手册2020-3-3.docx';
    // http://52.81.91.72:9456/labpro/resources/document/（APP-normal）杂交水稻国家重点实验室管理系统产品使用手册.docx
    Modal.info({
      title: '系统操作手册下载链接',
      content: (
        <div>
          <p>&nbsp;&nbsp;</p>
          <p></p>
          <p></p>
          <p></p>
          <p><a href={httpStr} target='_blank'>（APP-normal）杂交水稻国家重点实验室管理系统产品使用手册.docx</a></p>
          <p><a href={httpStr1} target='_blank'>（APP-管理员）杂交水稻国家重点实验室管理系统产品使用手册.docx</a></p>
          <p><a href={httpStr2} target='_blank'>（C端程序）杂交水稻国家重点实验室管理系统产品使用手册.doc</a></p>
          <p><a href={httpStr3} target='_blank'>（PC web）杂交水稻国家重点实验室管理系统产品使用手册2020-3-3.docx</a></p>
        </div>
      ),
      onOk() { },
    });
  }
  keywordscolorful = (str, key) => {
    let reg = new RegExp("(" + key + ")", "g");
    let newstr = str.replace(reg, "<font style='color:#1890ff;'>$1</font>");
    return newstr;
  }
  setValue = (feild, value) => {
    this.setState({
      [feild]: value
    })
  }
  onchangeFrist = (value) => {
    if (!value) {
      console.log(11111)
      return
    }
    this.setState({
      value: value
    })
  }
  Searchonchange = (value) => {
    this.setValue('poDivSpin', true)
    let type = '';
    if (this.state.changeList) {
      type = this.state.changeList
    } else {
      type = '1,5,7,9,10'
    }
    reqByGet(servers.allSearch, { content: value, type }, res => {
      console.log(res)
      this.setValue('poDivSpin', false)
      this.setState({
        value: value,
        resulFlag: res.resulFlag,
        proList: res.proList,
        fundList: res.fundList,
        reaList: res.reaList,
        pdList: res.pdList,
        eqList: res.eqList
      })
    }, err => {
      this.setValue('poDivSpin', false)
      console.log(err)
    })
  }
  tochangeSelect = (e) => {
    this.setState({
      changeList: e
    })
    let type = e + ''
    if (e === 0) {
      type = '1,5,7,9,10'
    }
    this.setValue('poDivSpin', true)
    reqByGet(servers.allSearch, { content: this.state.value, type }, res => {
      console.log(res)
      this.setValue('poDivSpin', false)
      this.setState({
        resulFlag: res.resulFlag,
        proList: res.proList,
        fundList: res.fundList,
        reaList: res.reaList,
        pdList: res.pdList,
        eqList: res.eqList
      })
    }, err => {
      this.setValue('poDivSpin', false)
      console.log(err)
    })
  }

  render() {
    const that = this;
    const { app: { headerPaneKey, headerPanes }, user: { userObj: { roleId } } } = this.props
    const { settingMenu, logoImg, current, pageName } = this.state;
    const userMenu = (
      <ul className={styles.userMenu}>
        {roleId !== 2 && <li>
          <Link to="/userCenter">个人中心</Link>
        </li>}
        <li onClick={() => this.loginOut()}>
          <a>退出登录</a>
        </li>
      </ul>
    );
    const usetMsg = (
      // <ul className={styles.userMenu}>
      //   <li>
      //     <Link to="/userCenter">个人中心</Link>
      //   </li>
      //   <li onClick={() => this.loginOut()}>
      //     <a>退出登录</a>
      //   </li>
      // </ul>
      <div className='f14'>消息中心</div>
    )
    const settingMenus = (
      <ul className={styles.userMenu}>
        {settingMenu && settingMenu.subMenu.map(item => {
          return (
            <li key={item.link}>
              <Link to={item.link}>{item.name}</Link>
            </li>
          )
        })}
      </ul>
    );
    const labMenu = (
      <Menu className="tc">
        {this.state.labMenus.length > 0 && this.state.labMenus.map(item => {
          return (
            <Menu.Item key={item.labId} onClick={() => {
              that.switchLab(item)
            }}>
              <span>{item.labName}</span>
            </Menu.Item>
          )
        })}
      </Menu>
    )
    return (
      <div className={styles.body_header} id="Header">
        <h2>
          {pageName && <span>{pageName.split('')[0] || ''}</span>}
          {pageName}
          {/* {(this.state.labMenus.length > 0 && !localStorage.getItem('userFlag')) &&
            <Dropdown overlay={labMenu} trigger={['click']} style={{ marginLeft: '10px' }} getPopupContainer={() => document.getElementById('Header')}>
              <a className={styles.header_labList}>{that.state.curLab.labName} <Icon type="down" /></a>
            </Dropdown>
          } */}
        </h2>
        <Menu style={{ maxWidth: document.body.clientWidth - 600 + 'px' }} onClick={this.menuClick} mode="horizontal" className="headerMenu" selectedKeys={[headerPaneKey]}>
          {headerPanes.map(item => {
            return <Menu.Item key={item.key}>{item.title}</Menu.Item>
          })}
        </Menu>
        {this.props.path === '/msg' && <div className='fr allread'>
          <Button type="primary" onClick={() => this.onclickAllRead()}>一键已读</Button>
        </div>}
        {this.props.path !== '/msg' &&
          <div className='uiDiv'>
            {this.props.path === '/homePage' && roleId !== 2 &&
              <div style={{ marginRight: "50px" }}>
                <Input.Search
                  ref={(input) => { this.inputRef = input; }}
                  className='mr20 allSearch pr'
                  placeholder="搜索"
                  autofocus={this.state.isautofocus}
                  onFocus={() => this.setState({ isOne: 1 })}
                  onBlur={() => this.setState({ isOne: this.state.isonmouse ? 1 : 0 })}
                  onChange={e => this.onchangeFrist(e.target.value)}
                  onSearch={value => this.Searchonchange(value)}
                  style={{ width: 200 }}
                />

                <div className='podiv' onClick={() => {
                  const { input } = this.inputRef
                  input.focus()
                }} onMouseEnter={() => {
                  this.setState({ isonmouse: true })
                  const { input } = this.inputRef
                  input.focus()
                }} onMouseLeave={() => {
                  this.setState({ isonmouse: false })
                }}
                  style={{ display: this.state.isOne ? "block" : 'none' }}>

                  <div className='clear'>
                    <span className='s1'>相关词匹配</span>
                    <Select
                      className='pSelect'
                      style={{ width: 100 }}
                      defaultValue={0}
                      size="small"
                      onFocus={() => {
                        // const { input } = this.inputRef
                        // input.focus()
                      }}
                      onBlur={() => {
                        const { input } = this.inputRef
                        input.focus()
                      }}
                      onChange={this.tochangeSelect}
                    >
                      <Select.Option key={0} value={0}>全部</Select.Option>
                      <Select.Option key={1} value={1}>课题</Select.Option>
                      <Select.Option key={9} value={9}>经费</Select.Option>
                      <Select.Option key={5} value={5}>试剂耗材</Select.Option>
                      <Select.Option key={7} value={7}>仪器设备</Select.Option>
                      <Select.Option key={10} value={10}>文件</Select.Option>
                    </Select>
                  </div>

                  <Scrollbars className='myScroll treeScroll' style={{ height: '200px' }}>
                    <Spin spinning={this.state.poDivSpin}>
                      {this.state.resulFlag === 'false' &&
                        <div style={{ margin: 'auto', padding: '28px 73px' }}>
                          <img src={servers.defaultNoContentPath} alt="暂无内容" className="noContent" style={{ width: "125px" }} />
                        </div>
                      }
                      {this.state.proList && this.state.proList.length > 0 && <List
                        header='课题'
                        className='alllist'
                        bordered={false}
                        dataSource={this.state.proList}
                        renderItem={(item, index) => {
                          return (
                            <List.Item key={index}><Link
                              to={{
                                pathname: item.type === 1 ? `/project_child2/${item.allId}` : item.type === 2 ? `/project_task2/${item.allId}` : `/report_list/${item.allId}`,
                                state: item.parentId
                              }}
                              className='toproject' dangerouslySetInnerHTML={{ __html: item.allName.length > 15 ? this.keywordscolorful(item.allName.substring(0, 16), this.state.value) + '...' : this.keywordscolorful(item.allName, this.state.value) }} ></Link></List.Item>
                          )
                        }}
                      />}
                      {this.state.fundList && this.state.fundList.length > 0 && <List
                        header='经费'
                        className='alllist'
                        bordered={false}
                        dataSource={this.state.fundList}
                        renderItem={(item, index) => {
                          return (
                            <List.Item key={index}><Link to={
                              `/fundManagementchild/${item.allId}`
                            } className='toproject' dangerouslySetInnerHTML={{ __html: item.allName.length > 15 ? this.keywordscolorful(item.allName.substring(0, 16), this.state.value) + '...' : this.keywordscolorful(item.allName, this.state.value) }}></Link></List.Item>
                          )
                        }}
                      />}
                      {this.state.reaList && this.state.reaList.length > 0 && <List
                        header='试剂'
                        className='alllist'
                        bordered={false}
                        dataSource={this.state.reaList}
                        renderItem={(item, index) => {
                          return (
                            <List.Item key={index}><Link
                              to={{
                                pathname: "/medicine",
                                state: {
                                  allId: item.id
                                }
                              }} className='toproject' dangerouslySetInnerHTML={{ __html: item.name.length > 15 ? this.keywordscolorful(item.name.substring(0, 16), this.state.value) + '...' : this.keywordscolorful(item.name, this.state.value) }}></Link></List.Item>
                          )
                        }}
                      />}
                      {this.state.pdList && this.state.pdList.length > 0 && <List
                        header='文件'
                        className='alllist'
                        bordered={false}
                        dataSource={this.state.pdList}
                        renderItem={(item, index) => {
                          return (
                            <List.Item key={index}><Link
                              to={{
                                pathname: "/pDiskFileList",
                                state: {
                                  allId: item.id,
                                  activeTreeKey: item.allid
                                }
                              }}
                              className='toproject' dangerouslySetInnerHTML={{ __html: item.docName.length > 15 ? this.keywordscolorful(item.docName.substring(0, 16), this.state.value) + '...' : this.keywordscolorful(item.docName, this.state.value) }} ></Link></List.Item>
                          )
                        }}
                      />}
                      {this.state.eqList && this.state.eqList.length > 0 && <List
                        header='仪器'
                        className='alllist'
                        bordered={false}
                        dataSource={this.state.eqList}
                        renderItem={(item, index) => {
                          return (
                            <List.Item key={index}><Link
                              to={{
                                pathname: "/eqAppoint",
                                state: {
                                  allId: item.id
                                }
                              }}
                              className='toproject' dangerouslySetInnerHTML={{ __html: item.name.length > 15 ? this.keywordscolorful(item.name.substring(0, 16), this.state.value) + '...' : this.keywordscolorful(item.name, this.state.value) }}></Link></List.Item>
                          )
                        }}
                      />}
                    </Spin>
                  </Scrollbars>
                </div>
              </div>}
            {roleId !== 2 && <Popover placement="bottom" content={<div>国自基金大数据</div>} className='mr20 msg listAll'>
              <Link to='/fundCheck'>
                <i className="iconfont icon-tubiaozhizuomoban-014  f26 myI0 c_999"></i>
              </Link>
            </Popover>}
            {roleId !== 2 && <Popover placement="bottom" content={<div>工作清单</div>} className='mr20 msg listAll'>
              <Badge
                dot={this.state.msgFlag1}
                count={this.props.dateNum}
                overflowCount={99}
                className=''
                onMouseEnter={() => this.setState({ msgFlag1: false })}
                onMouseLeave={() => this.setState({ msgFlag1: true })}>
                <Link to='/myList'>
                  <i className="iconfont icon-dingdan f32 myI0 c_999"></i>
                </Link>
              </Badge>
            </Popover>}
            {roleId !== 2 && <Popover placement="bottom" content={usetMsg} className='mr20 supDot msg'>
              <Badge dot={this.state.msgFlag} count={this.props.msgNum} overflowCount={99} className='' onMouseEnter={() => this.setState({ msgFlag: false })} onMouseLeave={() => this.setState({ msgFlag: true })}>
                <Link to='/msg'>
                  <i className="iconfont icon-lujing f20 myI0 c_999"></i>
                </Link>
              </Badge>
            </Popover>}
            {/* {(settingMenu && settingMenu.subMenu && settingMenu.subMenu.length > 0) &&
              <Popover placement="bottom" trigger="hover" content={settingMenus} className='mr10'>
                <a><i className="iconfont icon-xitong f20"></i></a>
              </Popover>
            } */}
            <Popover placement="bottom" content={userMenu} className='mr10'>
              <div className="f12" style={{ cursor: "pointer" }}>
                <Avatar size={38} src={this.props.user && this.props.user.userObj.headPath ? (servers.basePath + this.props.user.userObj.headPath) : servers.defaultAvator} style={{ backgroundColor: '#1890ff' }} />
              </div>
            </Popover>
            <span className='mr15'>
              {this.props.user && this.props.user.userObj && this.props.user.userObj.nickName && this.props.user.userObj.nickName.length > 8 ? this.props.user.userObj.nickName.substring(0, 8) + '...' : this.props.user.userObj.nickName}</span>
            {/* <a onClick={() => this.showRule()} className='mr10'>
              <Icon type="question-circle" className={styles.credit_showRule + ' f16'} />
            </a> */}
          </div>}

      </div>
    );
  }/**
           * <Icon type="question-circle" className={styles.credit_showRule} onClick={()=>this.showRule()}/>
           */
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    selectBox: state.selectBox,
    msgNum: state.msgNum,
    dateNum: state.dateNum,
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...boxActions, ...msgNumActions, ...dateNumActions, ...appActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);

  // export default Header;